import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {StateProviderService} from '../services/state-provider.service';
import {tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HasParamGuard implements CanActivate {
  constructor(private stateProviderService: StateProviderService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const requiredParams = next.data.requiredParams as Array<string>;
    if (!requiredParams || !requiredParams.length) {
      return true;
    }

    const hasAllRequiredParams = requiredParams.map(param => this.stateProviderService.getParam(param)).every(value => !!value);
    return of(hasAllRequiredParams).pipe(
      tap(skipRedirect => {
        if (!skipRedirect && next.data.navigateFallback) {
          this.router.navigate([next.data.navigateFallback]);
        }
      })
    );
  }
}
